import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { ProjectTemplate } from 'app/modules/projects/projects.types';

@Component({
  selector: 'property-change-template',
  templateUrl: './property-change-template.component.html',
  styleUrls: ['./property-change-template.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PropertyChangeTemplateComponent implements OnInit {
  projectForm: UntypedFormGroup;

  projectTemplates: ProjectTemplate<any>[];

  private _unsubscribeAll: Subject<void>;
  public uploadedFile: any;
  options: [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<PropertyChangeTemplateComponent>,
    private _formBuilder: UntypedFormBuilder,
  ) {
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.projectForm = this._formBuilder.group({
      id: [''],
      template_id: [''],
    });

    this.projectTemplates = this.data.options.project_templates
      .filter((option) => !option.hidden && option.related_to_type == this.data.related_to_type && option.listed)
      .sort((a, b) => a.name.localeCompare(b.name));
    if (this.data.template_id) {
      this.projectForm.get('template_id').setValue(this.data.template_id);
    }
  }

  onFileChanged($event) {
    let file = $event.target.files[0];
    this.uploadedFile = file;
  }

  discard(): void {
    this.matDialogRef.close();
  }

  save(): void {
    this.projectForm.disable();
    this.matDialogRef.close({ template_id: this.projectForm.get('template_id').value });
  }
}
